import iconCompliance from './icon-compliance.svg';
import iconConsulting from './icon-consulting.svg';
import iconDeterminations from './icon-determinations.svg';
import iconEmissions from './icon-emissions.svg';
import iconHazwaste from './icon-hazwaste.svg';
import iconParsing from './icon-parsing.svg';
import iconTierii from './icon-tierii.svg';
import iconTri from './icon-tri.svg';
import type { AppID } from '../../cross-app-shared/types/db';

type PlatformArtwork = {
  name: string;
  label: string;
  description: string;
  svgPrefix: string;
  iconUrl: string;
  app: AppID | null;
};

// Shared brand metadata for the public login and tenant-scoped Mission Control.
// SVG prefixes match the icon and label element IDs in platform-orbit.svg.
export const platformAppArtwork = {
  compliance: {
    name: 'Compliance Tool',
    label: 'Compliance',
    description: 'Track requirements, tasks, and deadlines.',
    svgPrefix: 'compliance',
    iconUrl: iconCompliance,
    app: 'compliance',
  },
  hazwaste: {
    name: 'Waste Tool',
    label: 'Waste',
    description: 'Manage hazardous waste and generator requirements.',
    svgPrefix: 'waste',
    iconUrl: iconHazwaste,
    app: 'hazwaste',
  },
  tierii: {
    name: 'Tier II',
    label: 'Tier II',
    description: 'Prepare chemical inventory reports and state submissions.',
    svgPrefix: 'tier2',
    iconUrl: iconTierii,
    app: 'tierii',
  },
  tri: {
    name: 'TRI Tool',
    label: 'TRI',
    description: 'Calculate reporting thresholds and prepare Form R submissions.',
    svgPrefix: 'tri',
    iconUrl: iconTri,
    app: 'tri',
  },
  parsing: {
    name: 'Parsing Tool',
    label: 'Parsing',
    description: 'Turn permit requirements into compliance tasks.',
    svgPrefix: 'parsing',
    iconUrl: iconParsing,
    app: 'parsing',
  },
  emissions: {
    name: 'Emissions Tool',
    label: 'Emissions',
    description: 'Track emissions, limits, and reporting periods.',
    svgPrefix: 'emissions',
    iconUrl: iconEmissions,
    app: 'emissions',
  },
  determinations: {
    name: 'Determination Tool',
    label: 'Determination',
    description: 'Find which environmental regulations apply to your facility.',
    svgPrefix: 'determination',
    iconUrl: iconDeterminations,
    app: 'determinations',
  },
} as const satisfies Record<AppID, PlatformArtwork>;

export const platformConsultingArtwork = {
  name: 'Consulting',
  label: 'Consulting',
  description: 'Get help with environmental compliance and reporting.',
  svgPrefix: 'consulting',
  iconUrl: iconConsulting,
  app: null,
} as const satisfies PlatformArtwork;
